// Tab-only restricted continuation. It never contains a password, user or normal token.
const key = 'ts.transfer.v1';
const flowKey = 'ts.transfer.flow.v1';
export function createTransferState(storage, randomId, now = () => Date.now()) {
    let current = null, completed = false;
    const valid = p => p && p.Version === 1 && typeof p.Proof === 'string' && p.Proof.startsWith('tsc1.') && p.Proof.length <= 2048 &&
        typeof p.ExpiresUtc === 'string' && Number.isFinite(Date.parse(p.ExpiresUtc)) && Date.parse(p.ExpiresUtc) <= now() + 300000 &&
        Number.isInteger(p.RetryAfterSeconds) && p.RetryAfterSeconds >= 0 && p.RetryAfterSeconds <= 300 &&
        ['pending', 'expired', 'exhausted', 'throttled', 'used', 'cancelled', 'stale'].includes(p.State);
    function clear() { current = null; completed = true; storage.removeItem(key); }
    return {
        flow() {
            let value = storage.getItem(flowKey);
            if (!/^[a-f0-9-]{36}$/.test(value || '')) { value = randomId(); storage.setItem(flowKey, value); }
            return value;
        },
        resume() {
            if (completed) return null;
            try {
                const p = JSON.parse(storage.getItem(key));
                if (!valid(p)) { storage.removeItem(key); return null; }
                current = p;
                return { ...p, State: Date.parse(p.ExpiresUtc) <= now() ? 'expired' : p.State };
            } catch { storage.removeItem(key); return null; }
        },
        accept(p) {
            if (completed || !valid(p) || (current && (p.Proof !== current.Proof || p.ExpiresUtc !== current.ExpiresUtc))) throw new Error('Invalid transfer continuation');
            if (current && !['pending', 'throttled'].includes(current.State)) return { ...current };
            current = { Version: 1, Proof: p.Proof, ExpiresUtc: p.ExpiresUtc, RetryAfterSeconds: p.RetryAfterSeconds, State: p.State };
            storage.setItem(key, JSON.stringify(current));
            return { ...current };
        },
        clear,
        begin() { if (completed) { current = null; completed = false; } },
        restart() { clear(); completed = false; storage.removeItem(flowKey); },
        active: () => !completed && current && ['pending', 'throttled'].includes(current.State) && Date.parse(current.ExpiresUtc) > now()
    };
}
